import { z } from 'zod';
import {
  EmbedContentFieldSchema,
  FieldGroupSchema,
  FieldRole,
  BlockType,
  ColorSchemeSchema,
  RichTextFieldSchema,
} from './Types';

enum EmbedLayout {
  Right = 'right',
  Left = 'left',
  Center = 'center',
  NoText = 'noText',
}

const EmbedOptionsSchema = z.object({
  subheaderEnabled: z.boolean().optional(),
  style: z
    .object({
      backgroundColor: z.string().optional(),
    })
    .optional(),
  layout: z.nativeEnum(EmbedLayout).optional(),
  colorScheme: ColorSchemeSchema.optional(),
});

const EmbedHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});
const EmbedSubheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});

const EmbedHeaderAndSubheaderFieldGroupField = z.discriminatedUnion('name', [
  EmbedHeaderFieldSchema,
  EmbedSubheaderFieldSchema,
]);

const EmbedHeaderAndSubheaderFieldGroupFieldSchema = FieldGroupSchema.extend({
  fields: z.array(EmbedHeaderAndSubheaderFieldGroupField),
});
const EmbedContentFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(
    EmbedContentFieldSchema.extend({
      name: z.literal('embedContent'),
      role: z.literal(FieldRole.EmbedContent),
    }),
  ),
});

export const EmbedBlockConfigSchema = z.object({
  options: EmbedOptionsSchema,
  type: z.literal(BlockType.Embed),
  fieldGroups: z.tuple([EmbedHeaderAndSubheaderFieldGroupFieldSchema]).rest(EmbedContentFieldGroupSchema),
  version: z.literal(1),
});
